import { api } from './client';

/**
 * Inteligencia de ventas (centro del negocio). Prefijo: /api/ventas (ADMIN).
 * Tipos espejo de apps/api/src/services/ventas.service.ts.
 */

export type VentasPeriodo = 'hoy' | 'semana' | 'mes';

export interface TopModelo {
  modelo: string;
  cantidad: number;
  total: number;
}

export interface VentasResumen {
  periodo: VentasPeriodo;
  desde: string;
  hasta: string;
  ventas: number;
  totalVendido: number;
  sinPrecio: number;
  /**
   * S-01 · Cuánto del total salió del MONTO DEL CIERRE y no de la ficha de
   * despacho. Es la diferencia que explica por qué el resumen de las 8 PM y
   * este número pueden no coincidir: sin mostrarla, parece un error.
   */
  totalDesdeCierre: number;
  ventasDesdeCierre: number;
  ticketPromedio: number | null;
  topModelos: TopModelo[];
  leadsEntrados: number;
  conversion: number | null;
}

export const getVentasResumen = (periodo: VentasPeriodo) =>
  api.get<VentasResumen>('/api/ventas/resumen', { query: { periodo } });
